import { files as fileUtils, printDocument, printHtml } from '@/shared/utils/files';

import { FileInfo, FilePreviewData, FilePreviewProps } from './types';

const types = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/png',
  'image/jpg',
  'image/jpeg',
  'image/heic',
  'image/heif',
  'image/tiff',
];

export const isSupportedType = (type: string) => {
  if (types.includes(type)) return true;

  return false;
};

export const getFileInfo = (data: FilePreviewData) => {
  return {
    fileData: data.mode === 'fileInfo' ? data.fileInfo : data.file,
    fileDocument: data.mode === 'file' ? data.file : data.fileInfo,
    isSupported: data.mode === 'file' && isSupportedType(data.file.type),
  };
};

export const mimeTypeToFileInfoFileType = (type: string): FileInfo['fileType'] | null => {
  if (type === 'application/pdf') return 'pdf';
  if (type.startsWith('image/')) return 'image';
  if (type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return 'xlsx';
  if (type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
    return 'docx';

  return null;
};

export const printPreview = (props: FilePreviewProps, previewHtml?: string) => {
  const ext = props.mode === 'file' ? fileUtils.getExtension(props.file.name) : null;
  if (
    (props.mode === 'fileInfo' &&
      (props.fileInfo.fileType === 'docx' || props.fileInfo.fileType === 'xlsx')) ||
    (props.mode === 'file' && (ext === 'docx' || ext === 'xlsx'))
  ) {
    if (previewHtml) {
      const styles = `
        @page {
          margin: 0;
          size: auto;
        }
        body {
          margin: 0;
          padding: 0;
        }
        .docx-wrapper {
          background: white !important;
          padding: 0 !important;
        }
        .docx {
          margin: 0 !important;
          box-shadow: none !important;
          page-break-after: always;
        }
      `;
      printHtml(previewHtml, styles);
    }
    return;
  }

  if (props.mode === 'fileInfo') {
    printDocument(props.fileInfo.url);
  } else {
    // Not implemented for files
  }
};
